import { Input } from '@progress/kendo-react-inputs';
import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { FormFieldWrapper } from '../FormFieldWrapper';

interface FormNumberInputProps extends FieldRenderProps {
  isInteger: boolean;
  isLoading?: boolean;
}

const DECIMAL_PLACES_LIMIT = 6;

export const FormNumberInput: React.FC<FormNumberInputProps> = fieldRenderProps => {
  const { value, onChange, required, min, max, isInteger, disabled, isLoading } = fieldRenderProps;
  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <Input
        label={undefined}
        value={value}
        onChange={e => {
          const newValue = e.target.value as string;
          if (isInteger) {
            if (/^-?\d*$/.test(newValue)) {
              onChange(e);
            }
          } else {
            const decimalRegex = new RegExp(`^-?\\d*(\\.\\d{0,${DECIMAL_PLACES_LIMIT}})?$`);
            if (decimalRegex.test(newValue)) {
              onChange(e);
            }
          }
        }}
        type="number"
        required={required}
        min={min}
        max={max}
        step={isInteger ? 1 : Math.pow(10, -DECIMAL_PLACES_LIMIT)}
        disabled={disabled}
      />
    </FormFieldWrapper>
  );
};
